import { render, staticRenderFns } from "./SampleProjects.vue?vue&type=template&id=59a37bac&scoped=true&"
import script from "./SampleProjects.vue?vue&type=script&lang=js&"
export * from "./SampleProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a37bac",
  null
  
)

export default component.exports